<template>
    <div class="releaseflow-list">
        <v-card>
            <v-card-title style="background-color: rgb(33, 57, 141); color: white;">
                Release flows
                <v-spacer></v-spacer>
                <v-btn dark icon :to="{name: 'release-flow-detail'}"><v-icon>add</v-icon></v-btn>
            </v-card-title>

                <v-data-table
                        :headers="headers"
                        :items="loadAll"
                        :pagination.sync="pagination"
                        class="elevation-1"
                >
                    <template v-slot:items="props">
                        <td>{{ props.item.attributes.title }}</td>
                        <td class="text-sm-right">
                            <v-btn icon :to="{ name: 'release-flow-detail', params: { id: props.item.id }}"><v-icon color="primary">edit</v-icon></v-btn>
                            <v-btn icon @click="deletePost(props.item);"><v-icon color="primary">delete</v-icon></v-btn>
                        </td>
                    </template>
                </v-data-table>
        </v-card>
    </div>
</template>

<script  >
    import {mapActions, mapGetters} from 'vuex';

    export default {
        mounted() {
            this.loadAllPosts();
        },
        methods: {
            ...mapActions({
                loadAllPosts: 'releaseFlows/loadAll',
                deletePost: 'releaseFlows/delete',
            }),
        },
        computed: {
            ...mapGetters({
                loading: "releaseFlows/isLoading",
                error: "releaseFlows/isError",
                loadAll: "releaseFlows/all",
            }),
        },
        data() {
            return {
                title: "",
                headers: [
                    {text: "Name", value: "attributes.title"},
                    {text: "", value: "actions"}
                ],
                pagination: {
                    rowsPerPage: 10,
                },
            };
        },
    };
</script>
